import React, { Component } from 'react'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import WithPatient from '../../conditions/WithPatient'
import PrintLogin from './PrintLogin'
import PrintPlan from './PrintPlan'
import PrintScreening from './PrintScreening'

export default class Print extends Component {
  render() {
    const { match } = this.props
    const { patientID, whatToPrint } = match.params

    if (patientID === 'demo') {
      return (
        <WithPatient patientID="demo">
          {whatToPrint === 'plan' && <PrintPlan />}
          {whatToPrint === 'login' && <PrintLogin />}
          {whatToPrint === 'screening' && <PrintScreening />}
        </WithPatient>
      )
    }

    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <WithPatient patientID={patientID}>
          {whatToPrint === 'plan' && <PrintPlan />}
          {whatToPrint === 'login' && <PrintLogin />}
          {whatToPrint === 'screening' && <PrintScreening />}
        </WithPatient>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Print/index.js